/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 上限
 * @export
 * @interface CapacitiesRow
 */
export interface CapacitiesRow {
    /**
     * 乗務員ID
     * @type {number}
     * @memberof CapacitiesRow
     */
    officeId: number;
    /**
     * 営業所名称
     * @type {string}
     * @memberof CapacitiesRow
     */
    officeName: string;
    /**
     * 乗務員ID
     * @type {number}
     * @memberof CapacitiesRow
     */
    driverId: number;
    /**
     * 乗務員番号
     * @type {string}
     * @memberof CapacitiesRow
     */
    driverCode: string;
    /**
     * 乗務員名
     * @type {string}
     * @memberof CapacitiesRow
     */
    driverName: string;
    /**
     * 利用開始日
     * @type {number}
     * @memberof CapacitiesRow
     */
    startedDate: number;
    /**
     * 上限金額
     * @type {number}
     * @memberof CapacitiesRow
     */
    capPrice: number;
    /**
     * 上限回数
     * @type {number}
     * @memberof CapacitiesRow
     */
    capTrips?: number;
}

export function CapacitiesRowFromJSON(json: any): CapacitiesRow {
    return CapacitiesRowFromJSONTyped(json, false);
}

export function CapacitiesRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): CapacitiesRow {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'officeId': json['office_id'],
        'officeName': json['office_name'],
        'driverId': json['driver_id'],
        'driverCode': json['driver_code'],
        'driverName': json['driver_name'],
        'startedDate': json['started_date'],
        'capPrice': json['cap_price'],
        'capTrips': !exists(json, 'cap_trips') ? undefined : json['cap_trips'],
    };
}

export function CapacitiesRowToJSON(value?: CapacitiesRow | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'office_id': value.officeId,
        'office_name': value.officeName,
        'driver_id': value.driverId,
        'driver_code': value.driverCode,
        'driver_name': value.driverName,
        'started_date': value.startedDate,
        'cap_price': value.capPrice,
        'cap_trips': value.capTrips,
    };
}


